export const contractManageOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		addBtn: false,
		viewBtn: true,
		excelBtn: true,
		delBtn: true,
		delBtnText: '清除绑定关系',
		editBtn: false,
		menuAlign: 'center',
		menuWidth: 180,
		searchLabelWidth: 120,
		searchMenuSpan: 24,
		searchMenuPosition: 'right',
		gutter: 20,
		labelWidth: 160,
		selection: true,
		column: [
			{
				label: '合同编号',
				prop: 'taskId',
			},
			{
				label: '用户姓名',
				prop: 'name',
				search: true,
			},

			{
				label: '手机号',
				prop: 'mobile',
				search: true,
			},
			{
				label: '身份证',
				prop: 'idNo',
				search: true,
			},
			{
				label: '工号',
				prop: '',
				formatter: ({id}) => {
					return `BWGD0767052${id}`
				},
			},
			{
				label: '性别',
				prop: 'sex',
			},
			{
				label: '文化程度',
				prop: 'education',
				type: 'select',
				dicUrl: `/admin/dict/type/education`,
			},
			{
				label: '政治面貌',
				prop: 'political',
				type: 'select',
				dicUrl: `/admin/dict/type/political`,
			},
			{
				label: '身份证原件',
				prop: 'originalIdcard',
				type: 'img',
			},
			{
				label: '关联账号',
				prop: 'channelName',
				bind: 'channel.name',
			},
			{
				label: '关联账号',
				prop: 'userId',
				bind: 'channel.name',
				hide: true,
				search: true,
			},
			//信息完整度， hasSettleAccount 1为信息完整， 0 信息缺失
			{
				label: '代理人结算信息',
				prop: 'hasSettleAccount',
				type: 'select',
				search: true,
				dicData: [
					{
						label: '信息完整',
						value: 1,
					},
					{
						label: '信息缺失',
						value: 0,
					},
				],
			},
			//MATERIAL_PENDING 材料待提交，MATERIAL_SUBMITTED 材料已提交，CONTRACT_SIGNED 合同已签署，VERIFY_SUBMITTED 认证已提交，VERIFY_SUCCESS 认证成功，VERIFY_FAIL 认证失败
			{
				label: '状态',
				prop: 'status',
				type: 'select',
				multiple: true,
				dataType: 'string',
				search: true,
				dicData: [
					{
						label: '材料待提交',
						value: 'MATERIAL_PENDING',
					},
					{
						label: '材料已提交,合同待签署',
						value: 'MATERIAL_SUBMITTED',
					},
					{
						label: '合同已签署，等待系统通知认证',
						value: 'CONTRACT_SIGNED',
					},
					{
						label: '"金事通"认证已提交',
						value: 'VERIFY_SUBMITTED',
					},
					{
						label: '"金事通"认证成功',
						value: 'VERIFY_SUCCESS',
					},
					{
						label: '"金事通"认证失败',
						value: 'VERIFY_FAIL',
					},
				],
			},
			{
				label: '重签合同编号',
				prop: 'resignTaskId',
			},
			{
				label: '重签状态',
				prop: 'resignStatus',
				type: 'select',
				search: true,
				dicData: [
					{
						label: '不需重签',
						value: 0,
					},
					{
						label: '需要重签',
						value: 1,
					},
					{
						label: '重签完成',
						value: 2,
					},
				],
			},
			{
				label: '创建时间',
				prop: 'createTime',
				search: true,
				type: 'datetime',
				valueFormat: 'yyyy-MM-dd HH:mm:ss',
				searchRange: true,
				width: 160,
			},
			{
				label: '更新时间',
				prop: 'updateTime',
				type: 'datetime',
				width: 160,
			},
		],
	}
}
